'use es6';

import styled from 'styled-components';
import UILink from 'UIComponents/link/UILink';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledHelpText = styled(UILink).withConfig({
  displayName: "HelpText__StyledHelpText",
  componentId: "h9rn4s-0"
})(["padding-top:14px;"]);
const HelpText = () => {
  return /*#__PURE__*/_jsx(StyledHelpText, {
    external: true,
    href: "https://knowledge.hubspot.com/resources/what-should-i-do-if-hubspot-videos-are-not-playing",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "ui-addon-video-player.havingTroubleWithVideoLink"
    })
  });
};
export default HelpText;